export function isNonEmptyAnswer(answer) {
  return answer && (!!answer.comment || answer.score != null);
}
